"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.belowOrEqualTo = exports.above = exports.breakpoints = exports.Breakpoint = void 0;
var spacing_1 = require("./spacing");
/**
 * We don't want breakpoints to change based on the user's default font
 * size, so for Breakpoints we specifically stringify them as pixels.
 */
var Breakpoint = /** @class */ (function (_super) {
    __extends(Breakpoint, _super);
    function Breakpoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Breakpoint.fromPixels = function (px) {
        return new Breakpoint(px + "px");
    };
    return Breakpoint;
}(spacing_1.Spacing));
exports.Breakpoint = Breakpoint;
exports.breakpoints = {
    xs: Breakpoint.fromPixels(480),
    sm: Breakpoint.fromPixels(576),
    md: Breakpoint.fromPixels(768),
    lg: Breakpoint.fromPixels(992),
    xl: Breakpoint.fromPixels(1200),
    xl2: Breakpoint.fromPixels(1600),
};
/* Usage:
    @media ${({ theme }) => above(theme.breakpoints.lg)} {
      // styles for (min-width: 993px)
    }
*/
function above(breakpoint) {
    return "(min-width: " + (breakpoint.getValue() + 1) + "px)";
}
exports.above = above;
/* Usage:
    @media ${({ theme }) => belowOrEqualTo(theme.breakpoints.lg)} {
      // styles for (max-width: 992px)
    }
*/
function belowOrEqualTo(breakpoint) {
    return "(max-width: " + breakpoint.getValue() + "px)";
}
exports.belowOrEqualTo = belowOrEqualTo;
//# sourceMappingURL=breakpoints.js.map